import { render, staticRenderFns } from "./givePresent.vue?vue&type=template&id=571ec5a0&scoped=true&"
import script from "./givePresent.vue?vue&type=script&lang=js&"
export * from "./givePresent.vue?vue&type=script&lang=js&"
import style0 from "./givePresent.vue?vue&type=style&index=0&id=571ec5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ec5a0",
  null
  
)

export default component.exports